import { HttpClient } from '@angular/common/http';
import { Injectable, TransferState } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';

import { Apollo } from 'apollo-angular';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { ExhibitionContentModel } from './models/exhibitionpage.model';
import { gql } from '@apollo/client/core';

@Injectable({
  providedIn: 'root'
})
export class ExhibitionContentService extends BaseGQLService<any> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: ExhibitionContentModel,
        clientName: 'ExhibitionContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryConferencesContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }

  override document = gql`
  query RootQuery($filter:String!,$skip:Int, $top:Int)
  {
    ${this.config.rootTypeName}(filter:$filter,skip:$skip, top:$top)
    {
        ${
          this.config.wrapperTypeName
            ? `${this.config.wrapperTypeName} { ${this.buildGQLProps()} } ${
                this.config.extraProps
              }`
            : `${this.buildGQLProps()}`
        }
    }
  }`;


}